import { FC } from 'react'

import { Avatar, Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'
import { PeopleChartMemberDetailFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface RowWithButtonProps {
  member: PeopleChartMemberDetailFragment
  updateMembership: () => void
  deleteMembership: () => void
}

const MemberRow: FC<RowWithButtonProps> = ({ member, updateMembership, deleteMembership }) => {
  return (
    <Box
      flexDirection="row"
      gap="s12"
      paddingX="s16"
      paddingY="s12"
      cursor="pointer"
      alignItems="center"
    >
      <Box>
        <Avatar
          size="s32"
          label={member.employee.fullName}
          url={buildUrl(member.employee.access?.avatar)}
        />
      </Box>
      <Box>
        <Text.Normal weight="bold">{member.employee.fullName}</Text.Normal>
        <Text.Normal>{member.employee.referenceContract?.jobTitle}</Text.Normal>
      </Box>
      <Box style={{ marginLeft: 'auto' }}>
        {member.lead && (
          <Tag type="grey" icon="add" rightItem="close" size="normal">
            {i18n.t('people_chart.employees_selector.leader')}
          </Tag>
        )}
      </Box>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption
            title={
              member.lead
                ? i18n.t('people_chart.employees_selector.unassign_leader.title')
                : i18n.t('people_chart.employees_selector.assign_leader.title')
            }
            description={
              member.lead
                ? i18n.t('people_chart.employees_selector.unassign_leader.description')
                : i18n.t('people_chart.employees_selector.assign_leader.description')
            }
            onClick={updateMembership}
          />
          <PopoverMenu.TouchableOption title={'Remove member'} onClick={deleteMembership} danger />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export default MemberRow
